import { FC } from 'react'
import { Typography } from 'antd'
import styled from 'styled-components'

interface MaterialWidthOptionLabelProps {
    width: number
    stock?: number
}

const Container = styled.div`
    display: flex;
    align-items: center;
`

const WidthText = styled.span`
    font-weight: 500;
    margin-right: 8px;
`

const StockText = styled(Typography.Text)`
    font-size: 12px;
`

const MaterialWidthOptionLabel: FC<MaterialWidthOptionLabelProps> = ({ width, stock = 0 }) => {
    return (
        <Container>
            <WidthText>{width} мм</WidthText>
            <StockText type='secondary'>Остатки: {stock} км</StockText>
        </Container>
    )
}

export default MaterialWidthOptionLabel
